import React from 'react'
import { Star, StarHalf, StarBorder } from '@mui/icons-material'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'

const Rating = ({ total = 0 }) => {
  const theme = useTheme()
  return (
    <>
      {[...Array(Math.floor(total))].map((key, i) => (
        <Star key={i} sx={{ color: theme.palette.yellow.main, fontSize: '1.25rem' }} />
      ))}
      {(total - Math.floor(total) && total - Math.floor(total)) !== 0 && (
        <StarHalf sx={{ color: theme.palette.yellow.main, fontSize: '1.25rem' }} />
      )}
      {[...Array(5 - Math.ceil(total))].map((key, i) => (
        <StarBorder
          key={i}
          sx={{ color: total <= 0 ? '#818181' : theme.palette.yellow.main, fontSize: '1.25rem' }}
        />
      ))}
    </>
  )
}

Rating.propTypes = {
  total: PropTypes.number,
}

export default Rating
